import counterup from 'counterup2';

export default {
	init() {
		// JavaScript to be fired on all pages
	},
	finalize() {
		$(document).on('change', '[type=radio]', function () {
			// Update display of the currently selected value whenever it's changed
			if ($(this).is(':checked')) {
				var star_val = 0;
				star_val = $(this).val();
				$.ajax({
					url: window.ajax_url,
					type: 'POST',
					data: 'action=my_special_ajax_call&star_rate_val=' + star_val,
					dataType: 'json',
					success: function (results) {
						if (results) {
							var total_rate = 0;
							var count = results.length;
							for (var i = 0; i < results.length; ++i) {
								total_rate = total_rate + parseInt(results[i]);
							}
							total_rate = total_rate / count;
							total_rate = Math.round(total_rate);
							if (total_rate > 5) {
								total_rate = 5;
							}
							$('.star-rating label').removeClass('light-star');
							$('div.star-rating').each(function () {
								var star_count = 0;
								$(this).find('label.star-label').each(function () {
									if (star_count <= total_rate) {
										$(this).addClass('light-star');
										star_count++;
									}
								});
							});
							$('input[name=my_rating]').attr('disabled', 'disabled');
							$('.star-rating').addClass('disable-hover');
							$('#desktop-val').text(total_rate);
							$('#mobile-val').text(total_rate);
						}
					},
				});
			}
		}).ready(function () {
			// Display the initial selected value (should be zero)
		});
		$(document).ready(function () {
			var current_star_rate = $('.current_star_rate').val();
			$.ajax({
				url: window.ajax_url,
				type: 'POST',
				data: 'action=my_get_cookie',
				success: function (results) {
					if (results) {
						console.log(results);
						$('input[name=my_rating]').attr('disabled', 'disabled');
						$('.star-rating').addClass('disable-hover');
					}
				},
			});
			$('div.star-rating').each(function () {
				var star_count = 0;
				$(this).find('label.star-label').each(function () {
					if (star_count <= current_star_rate) {
						$(this).addClass('light-star');
						star_count++;
					}
				});
			});

			//Filter faq
			$('select#sort-category').change(function () {
				//alert($(this).val());
				$('.items-wrapper li').hide();
				$('.items-wrapper li.' + $(this).val()).show();
			});
		});

		$('#search-btn').click(function () {
			$('.search-form').toggle();
			$('.orig').focus().tap();
		});

		$('#mobile-search').click(function () {
			$('.search-form').toggle();
		});

//partners slider
		$('.partners-slider').slick({
			dots: false,
			infinite: true,
			speed: 300,
			arrows: true,
			slidesToShow: 5,
			autoplay: true,
			autoplaySpeed: 2000,
			slidesToScroll: 1,
			responsive: [
				{
					breakpoint: 1024,
					settings: {
						slidesToShow: 4,
						slidesToScroll: 1,
						infinite: true,
						dots: false,
					},
				},
				{
					breakpoint: 991,
					settings: {
						slidesToShow: 4,
						infinite: true,
						slidesToScroll: 1,
						arrows: false,
					},
				},
				{
					breakpoint: 640,
					settings: {
						slidesToShow: 3,
						slidesToScroll: 1,
						autoplay: true,
						infinite: true,
						autoplaySpeed: 2000,
						arrows: false,
					},
				},
			],
		});


		//blog slider
		$('.blog-slider').slick({
			dots: false,
			infinite: true,
			speed: 300,
			arrows: true,
			slidesToShow: 5,
			autoplay: true,
			autoplaySpeed: 2000,
			slidesToScroll: 1,
			responsive: [
				{
					breakpoint: 1024,
					settings: {
						slidesToShow: 4,
						slidesToScroll: 1,
						infinite: true,
						dots: false,
					},
				},
				{
					breakpoint: 991,
					settings: {
						slidesToShow: 4,
						infinite: true,
						slidesToScroll: 1,
						arrows: false,
					},
				},
				{
					breakpoint: 640,
					settings: {
						slidesToShow: 3,
						slidesToScroll: 1,
						autoplay: true,
						infinite: true,
						autoplaySpeed: 2000,
						arrows: false,
					},
				},
			],
		});

//testimonial slider
		$('.testimonial-slider').slick({
			dots: false,
			infinite: true,
			speed: 300,
			arrows: true,
			slidesToShow: 3,
			autoplay: true,
			autoplaySpeed: 2000,
			slidesToScroll: 1,
			responsive: [
				{
					breakpoint: 1024,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 1,
						infinite: true,
						dots: false,
					},
				},
				{
					breakpoint: 767,
					settings: {
						slidesToShow: 1,
						infinite: true,
						slidesToScroll: 1,
					},
				},
				{
					breakpoint: 640,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1,
						autoplay: true,
						infinite: true,
						autoplaySpeed: 2000,
						arrows: false,
					},
				},
			],
		});

//Mobile Menu Toggle
		$('i.menu-chevron').on('click', function () {
			$(this).parent().find('.sub-menu').toggleClass('active');
		});

//kosten-verlagen
		$('.kosten-verlagen-slide').slick({
			dots: true,
			infinite: true,
			speed: 500,
			fade: true,
			cssEase: 'linear',
		});

		const el = jQuery('.counter-wrap__counter-block__list__counter-count');
		el.each(function () {
			counterup(this, {
				duration: 2000,
				delay: 15,
			});
		});


		$(document).ready(function () {

			function scrollOnPageLoad() {
				if (window.location.hash) {
					let heightNav = $('.solease-header').height();
					let scrollLocation = ($(window.location.hash).offset().top) - heightNav;
					console.log(scrollLocation);
					$('html, body').animate({
						scrollTop: scrollLocation,
					}, 1500, 'swing');
				}
			} scrollOnPageLoad();



			// Select all links with hashes
			$('a[href^="#"]')
				// Remove links that don't actually link to anything
				.not('[href="#"]')
				.not('[href="#0"]')
				.click(function (event) {
					// On-page links
					if (
						location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
						&&
						location.hostname == this.hostname
					) {
						let target = $(this.hash);
						let heightNav = $('.solease-header').height(),
							targetPx = (target.offset().top) - heightNav;


						// target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
						// Does a scroll target exist?
						if (target.length) {
							// Only prevent default if animation is actually gonna happen
							event.preventDefault();
							$('html, body').animate({
								scrollTop: targetPx,
							}, 1000, function () {
							});
						}
					}
				});


		});

	},
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js